import { useAppDispatch } from 'redux/store';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { getRestaurantId, getTableId, updateAppState } from 'redux/app';
import { getOrder, resetOrder } from 'redux/order';
import { useSelector } from 'react-redux';
import { Routes } from 'core/routes.types';
import { getMenuId } from 'redux/brand';
import { ConsumptionModeType } from 'services/consumptionMode/consumptionMode.type';
import { parseRestaurantId } from './utils/utils';

export const useHomeVM = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const dispatch = useAppDispatch();
    const restaurantId = parseRestaurantId(searchParams.get('restaurantId'));
    const tableId = searchParams.get('tableId');
    const hasParams = !!restaurantId && !!tableId;
    const stateRestaurantId = useSelector(getRestaurantId);
    const stateTableId = useSelector(getTableId);
    const currentMenuId = useSelector(getMenuId(restaurantId || null));
    const order = useSelector(getOrder);

    useEffect(() => {
        if (hasParams) {
            dispatch(
                updateAppState({
                    restaurantId,
                    currentMenuId,
                    tableId,
                    currentConsumptionModeType: ConsumptionModeType.MODE_SIT_IN, // MODE_SIT_IN default for MVP only
                }),
            );
        }
    }, [restaurantId, currentMenuId, tableId, hasParams, dispatch]);

    useEffect(() => {
        if (stateRestaurantId && stateTableId && currentMenuId) {
            if (
                (order && order.restaurantId !== stateRestaurantId) ||
                (order && order.menuId !== currentMenuId)
            ) {
                dispatch(resetOrder(undefined));
            }

            navigate(Routes.MenuHome);
        }
    }, [stateRestaurantId, stateTableId, currentMenuId, order, navigate, dispatch]);

    return { isError: !hasParams };
};
